export default class {

  constructor() {
    this.events()
    this.page = 1
    this.category = null
    this.month = null
    this.year = null
    this.setFilters()
  }

  getData( append = false ) {
    const $wrapper = $('.js-blogPosts__cards')
    const $button = $('.js-blogPosts__moreBtn')

    let url = '/wp-json/lrg/v1/blog_posts?'
    const params = {}

    if ( this.month ) {
      params['month'] = this.month
    }

    if ( this.year ) {
      params['selected_year'] = this.year
    }

    if ( this.category ) {
      params['category'] = this.category
    }

    if ( this.page > 1 ) {
      params['paged'] = this.page
    }
    
    if ( Object.keys(params) ) {
      url += $.param(params)
    }

    $wrapper.addClass('is-loading')
    $wrapper.append('<div class="l-spinner"><div class="l-spinner__el"></div></div>')

    $button.find('span').text('Loading...')
    $button.addClass('is-loading')

    $.get( url, function( posts ) {

      if ( posts) {

        const $spinner = $('.l-spinner')
        if ( $spinner.length ) {
          $spinner.remove()
        }

        if ( append ) {
          $button.parent().remove()
          $wrapper.append(posts)
        } else {
          $wrapper.html(posts)
        }
      }

      const $paramsEl = $('.js-blogPosts__url')

      if ( $paramsEl.length ) {
        const params = $paramsEl.text();
  
        const urlBase = window.location.href.split('?')[0]
        const newUrl = `${urlBase}?${params}`
  
        if( newUrl.length ){
          history.replaceState({data: params}, '', newUrl);
        }
        $paramsEl.remove()
      }

      $button.find('span').text('Show more')

    });
  }

  setFilters() {
    const that = this
    $('.js-blogPosts__dropdown').each(function() {
      const $this = $(this)
      if ( $this.hasClass('c-blogPosts__dropdown--year') ) {
        const value = $(this).val()
        if ( value ) {
          that.year = value
        }
      } else if ( $this.hasClass('c-blogPosts__dropdown--month') ) {
        const value = $(this).val()
        if ( value ) {
          that.month = value
        }
      } else if ( $this.hasClass('c-blogPosts__dropdown--category') ) {
        const value = $(this).val()
        if ( value ) {
          that.category = value
        }
      }
    })
  }

  events() { 
    $(document).on('click', '.js-blogPosts__moreBtn', (e) => {
      e.preventDefault()
      this.page++
      this.getData(true)
    })

    $('.js-blogPosts__dropdown').on('change', (e) => {

      const $this = $(e.target)
      const value = e.target.value

      this.page = 1

      if ( $this.hasClass('c-blogPosts__dropdown--year') ) {

        this.year = value
        this.getData()

      } else if ( $this.hasClass('c-blogPosts__dropdown--month') ) {

        this.month = value
        this.getData()

      } else if ( $this.hasClass('c-blogPosts__dropdown--category') ) {

        this.category = value
        this.getData()

      }
    })

  }

}